
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"21","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M1.786 1.333c0-.394.32-.714.714-.714h10c.395 0 .715.32.715.714v5a.714.714 0 01-1.429 0V2.048H3.215v16.904h8.571v-4.285a.714.714 0 111.429 0v5c0 .394-.32.714-.715.714h-10a.714.714 0 01-.714-.714V1.333zM13.595 7.571a.714.714 0 011-.142l3.333 2.5a.714.714 0 010 1.142l-3.333 2.5a.714.714 0 01-.857-1.143l2.571-1.928-2.571-1.929a.714.714 0 01-.143-1z"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M6.786 10.5c0-.395.32-.714.714-.714h10a.714.714 0 110 1.428h-10a.714.714 0 01-.714-.714z"}})])
          )
        }
      }
    